import { useContext } from "react";
import { useHistory } from "react-router-dom";
import { TableContext } from "../../index";
import * as urlService from "../../view/urlService";


export const useInventoryTableHelper = () => {

    const history = useHistory();
    const { config, setConfig } = useContext(TableContext);

    const hardReload = (props = {}) => {
        setConfig({
            ...config,
            selected: [],
            // selectAll: false,
            //hardReload: true,
            //lastUpdated: Date.now(),
            ...props
        });
    }

    const onHostClick = () => {
        history.push({
            pathname: history.pathname,
            search: urlService.updateSort('host')
        })
    }

    const onStatusClick = () => {
        history.push({
            pathname: history.pathname,
            search: urlService.updateSort('status')
        })
    }

    const onOSClick = () => {
        history.push({
            pathname: history.pathname,
            search: urlService.updateSort('os')
        })
    }



    return {
        hardReload,
        onHostClick,
        onStatusClick,
        onOSClick,
    }
}
